import { InteractiveState, SocketButtonPayload, SocketMessage } from './wire';

const RENDERABLE_BUTTON_TYPES: readonly string[] = ['postback', 'reply', 'web_url'];

const isSafeButtonUrl = (url: unknown): url is string => typeof url === 'string' && url.startsWith('https://');

export function filterUsableButtons(buttons: unknown): SocketButtonPayload[] {
  if (!Array.isArray(buttons)) return [];
  return buttons.filter((button): button is SocketButtonPayload => {
    const candidate = button as Partial<SocketButtonPayload> | null;
    return (
      !!candidate &&
      typeof candidate.title === 'string' &&
      candidate.title.trim() !== '' &&
      RENDERABLE_BUTTON_TYPES.includes(candidate.type as string)
    );
  });
}

export function sanitizeButtons(buttons: unknown): SocketButtonPayload[] {
  return filterUsableButtons(buttons).map(button => {
    if (button.type !== 'web_url') return button;
    if (isSafeButtonUrl(button.url)) return button;
    const { url: _rejected, ...rest } = button;
    return rest as SocketButtonPayload;
  });
}

export function isRecognizedInteractiveShape(interactive: unknown): interactive is InteractiveState | undefined {
  if (interactive === undefined || interactive === null) return true;
  if (typeof interactive !== 'object' || Array.isArray(interactive)) return false;
  const shape = interactive as Record<string, unknown>;
  if (shape.echoOnClick !== undefined && typeof shape.echoOnClick !== 'boolean') return false;
  if (shape.locked !== undefined && typeof shape.locked !== 'boolean') return false;
  if (shape.selectedBranchId !== undefined && typeof shape.selectedBranchId !== 'string') return false;
  if (shape.timedOutAt !== undefined && typeof shape.timedOutAt !== 'string') return false;
  if (shape.selections !== undefined && !Array.isArray(shape.selections)) return false;
  return true;
}

export function isRenderableButtonCard(message: SocketMessage): boolean {
  if (!message) return false;
  return filterUsableButtons(message.buttons).length > 0 && isRecognizedInteractiveShape(message.interactive);
}
